var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.746 11.628a.969.969 0 0 1 1.33-.001l3.239 3.053a1 1 0 0 0 1.371 0l3.24-3.053a.969.969 0 0 1 1.329 1.41l-4.568 4.314a1 1 0 0 1-1.373 0l-4.568-4.315a.969.969 0 0 1 0-1.408zm0-5a.969.969 0 0 1 1.33-.001l3.239 3.053a1 1 0 0 0 1.371 0l3.24-3.053a.969.969 0 0 1 1.329 1.41l-4.568 4.314a1 1 0 0 1-1.373 0L6.746 8.036a.969.969 0 0 1 0-1.408z","fill":"#9880BC"}));
}

ArrowUp.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
